import React, {Component} from 'react';
import YouTube from 'react-youtube';
import isUrl from 'is-url';
import getYouTubeID from 'get-youtube-id';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import { collapsibleSettings } from '../../helpers/Helpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";

class ExternalVideoField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            video: null
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                video: value
            });
        }
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    save() {
        this.props.input.onChange(this.state.video);

        this.setState({
            modal: false
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    clear() {
        const {input} = this.props;

        input.onChange(null);

        this.setState({
            link: {},
            video: null
        });
    }

    setVideo(url) {
        let videoId = getYouTubeID(url);

        if (videoId) {
            this.setState({
                video: {
                    url: url,
                    youtubeVideoId: videoId
                }
            });
        }
    }

    render() {
        const {modal, video} = this.state;
        const {input, label, meta: {touched, error}, expanded} = this.props;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                className={classNamesPrefixed({
                    'ExternalVideoField': true
                })}
                open={expanded}
            >
                {label && <label>{label}</label>}
                {input.value === '' ? (
                    <div
                        className={classNamesPrefixed({
                            'ExternalVideoField-empty': true
                        })}
                    >
                        <p>
                            <i
                                className={classNamesPrefixed({
                                    'grey-color': true
                                })}
                            >Add youtube video url.</i>
                        </p>
                        <div
                            className={classNamesPrefixed({
                                'form-actions': true
                            })}
                        >
                            <BtnSecondary
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.showModal();
                                }}
                            >
                                External video
                            </BtnSecondary>
                        </div>
                    </div>
                ) : (
                    <div
                        className={classNamesPrefixed({
                            'ExternalVideoField-selected': true
                        })}
                    >
                        <div
                            className={classNamesPrefixed({
                                'ExternalVideoField-video': true
                            })}
                        >
                            {video && video.url && video.youtubeVideoId &&
                            <YouTube
                                videoId={video.youtubeVideoId}
                                opts={{
                                    height: '260',
                                    width: '100%',
                                    playerVars: {
                                        autoplay: 0
                                    }
                                }}/>
                            }
                        </div>
                        <div
                            className={classNamesPrefixed({
                                'ExternalVideoField-info': true
                            })}
                        >
                            <div
                                className={classNamesPrefixed({
                                    'ExternalVideoField-info': true
                                })}
                            >
                                <a
                                    className={classNamesPrefixed({
                                        'link': true,
                                        'link-remove': true
                                    })}
                                    onClick={this.clear.bind(this)}
                                >
                                    <Icon name="times"/>Remove
                                </a>
                            </div>
                        </div>
                    </div>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
                <Modal
                    showModal={modal}
                    title="Add external video (Youtube)"
                    icon="video"
                    onClose={() => {
                        this.hideModal();
                    }}
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary
                                small
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.save();
                                }}>Save</BtnPrimary>
                        </div>
                    }
                >
                    <div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="video_url">Video link</label>
                            <input
                                type="text"
                                id="video_url"
                                name="video_url"
                                placeholder="https://www.youtube.com/watch?v=XkADiJCYS2k"
                                onChange={(e) => {
                                    let url = e.target.value;

                                    if (isUrl(url)) {
                                        this.setVideo(url);
                                    }
                                }}
                            />
                        </div>
                        {video && video.url && video.youtubeVideoId &&
                        <div
                            className={classNamesPrefixed({
                                'ExternalVideoField-video': true
                            })}
                        >
                            <YouTube
                                videoId={video.youtubeVideoId}
                                opts={{
                                    height: '260',
                                    width: '100%',
                                    playerVars: {
                                        autoplay: 0
                                    }
                                }}
                            />
                        </div>
                        }
                    </div>
                </Modal>
            </Collapsible>
        );
    }
}

export default ExternalVideoField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ExternalVideoField.js